"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (item) {
  return [].concat(item);
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/arrayify.js
// module id = 1651
// module chunks = 0